import React from "react";
import { Formik, Field } from "formik";
import FileUploadForm from "components/PLCTABS/CompanyOfficialsTab/FileUploadForm";
import Checkbox from "components/lib/Shared/Checkbox";
import { getChangedDocumentsModuleData } from "config/documentData";
import _get from "lodash/get";

const ApprovalDocuments = ({
  selectedTab,
  documentData,
  documentType,
  actionType,
  officialIndex = 0,
  fileUploads,
}) => {
  return (
    <div className="bg-white py-4 mt-4">
      <span className="px-2">
        Uploaded documents for {selectedTab} Approval
      </span>
      <div className="flex flex-col py-4 px-2">
        <h3 className="font-semibold text-slate-800">Document Selected:</h3>
        <div className="flex px-2 py-2 space-x-2">
          <Checkbox
            name="Signed Documents"
            label="Signed Documents"
            checked={documentData.docs[0].modeType === "pre-signed-documents"}
            disabled
          />
          <Checkbox
            name="notSignedDocuments"
            label="Not Signed Documents"
            checked={documentData.docs[0].modeType === "not-signed-documents"}
            disabled
          />
        </div>
      </div>
      <div className="py-4">
        <h3 className="font-semibold text-slate-800 px-2">Uploaded File:</h3>
        <Formik
          enableReinitialize
          initialValues={{
            fileUploads,
          }}
          onSubmit={() => null}
        >
          {() => (
            <div className="pl-4">
              <Field
                name="fileUploads"
                component={FileUploadForm}
                documentData={getChangedDocumentsModuleData(documentType)}
                resolvedFields={_get(documentData.docs[0], "resolvedFields")}
                onlyPreview
                showDocumentLabel
                addReviewComment={
                  actionType !== "incorporation-view" &&
                  actionType !== "manage-transaction-view"
                }
                hideResolveAllCheckbox={
                  actionType !== "incorporation-view" &&
                  actionType !== "manage-transaction-view"
                }
                formName="uploadChangeDocuments"
                formHelperKey="ManagerCompanyDocument"
                updateEffectKey={"updateOfficialManageModuleState"}
                updateEffectPath={`companyDashboardSlice.manageCompanyTransactions.items.${officialIndex}.${documentData.key}`}
                formId={_get(documentData.docs[0], "_id")}
                resolveAllFieldsCheckbox
                editorKey={documentData.docs[0].fileName}
                documentName={documentType}
              />
            </div>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default ApprovalDocuments;
